<template>
    <b-col class="notes-to-self">

        <b-row>
            <b-col cols="3"/>
            <b-col cols="6" class="notes-to-self__title">
                {{ $i18n.gt('HEADING_NOTES_TO_SELF') }}
            </b-col>
            <b-col cols="3" class="notes-to-self__saving">
                <template v-if="savingBool">
                    {{ $i18n.gt('LABEL_SAVING_INDICATOR') }}
                </template>
            </b-col>
        </b-row>

        <b-textarea class="mt-1" rows="10" @input="doAutoSave()" v-model="notesToSelf['notes']"/>

        <b-row class="mt-1 px-3" v-if="$mq !== 'sm' && $mq !== 'md'">
            <b-form-checkbox @input="doAutoSave()" class="col-9 align-self-center" v-model="notesToSelf['allowProviderView']">
                {{ $i18n.gt('LABEL_ALLOW_PROVIDERS_VIEW') }}
            </b-form-checkbox>
            <b-button class="col-3 my-2" @click="sendToProvider()">
                <b-icon-envelope/>
                {{ $i18n.gt('LABEL_SEND_TO_PROVIDER') }}
            </b-button>
        </b-row>
        <b-row class="mt-1 px-3" style="display: block" v-else>
            <b-row>
                <b-form-checkbox @input="doAutoSave()" class="align-self-center" v-model="notesToSelf['allowProviderView']">
                    {{ $i18n.gt('LABEL_ALLOW_PROVIDERS_VIEW') }}
                </b-form-checkbox>
            </b-row>
            <b-row>
                <b-button class="mx-3" style="width: 100%" @click="sendToProvider()">
                    <template>
                        {{ $i18n.gt('LABEL_SEND_TO_PROVIDER_MOBILE') }}
                    </template>
                </b-button>
            </b-row>
        </b-row>

    </b-col>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import Utils from '@/providers/Utils'

/**
 * Notes to self section for participants. Participants can opt in or out
 * of sharing these notes with their providers.
 */
export default Vue.extend({
    name: 'NotesToSelf',
    data () {
        return {
            savingBool : false
        }
    },
    computed : {
        participant() {
            return this.$store.state.patientParticipant
        },
        notesToSelf() {
            return this.setOrAdd()
        },
    },
    methods : {
        doAutoSave () {
            // update notes_edited time
            this.$store.state.patientParticipant.notes_edited = Utils.mysqlDatetime(new Date())
            this.$store.dispatch('savePatientParticipant')
        },
        setOrAdd () {
            if (!this.participant.wellness_plan.mindsetNotes) {
                this.participant.wellness_plan.mindsetNotes = {notes: '', allowProviderView: false}
            }
            return this.participant.wellness_plan.mindsetNotes
        },
        async sendToProvider() {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('MESSAGE_SEND_TO_PROVIDER_CONFIRM'), {title: this.$i18n.gt('LABEL_SEND_TO_PROVIDER')})){
                await this.$api.sendNotes(this)
                this.$toasted.show(this.$i18n.gt('MESSAGE_NOTES_SENT'), {duration: 3000})
            } else console.log('NotesToSelf:sendToProvider  not sent');
        }
    },
    created() {
        this.autoSave = _.debounce(this.doAutoSave, 1000)
    },
    watch: {
        '$store.state.saving': {
            handler: function (newVal, oldVal) {
                setTimeout(() => {
                    this.savingBool = newVal
                }, newVal ? 0 : 1000)
            }
        }
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.notes-to-self {
    cursor: pointer;

    .card {
        background: #fff;
        transition: all .3s;
        margin-bottom: 0;
        @media(min-width: 540px) {
            height:100%;
        }

    }
    @media(max-width:719px) {
        margin-bottom: 1rem;
    }
}

.notes-to-self__title {
    text-transform: uppercase;
    color: #666;
    font-size: .9em;
    text-align: center;
}

.notes-to-self__saving {
    color: #666;
    font-size: .9em;
    text-align: center;
}

</style>
